<template>
    <div class="courses-item-container">
        <v-img class="courses-img" :src="course.image == null ? courseAppleImg : course.image" height="100" contain>
            
        </v-img>
        <div class="courses-item-texts">
              <div class="courses-item-chip" v-if="showChip(course)">
                 <v-chip
                    outlined
                    x-small
                    :color="getColorChip(course)"
                    >{{ getCourseStatus(course) }}</v-chip>
              </div>

                 <p class="courses-item-texts-title text-left">{{ course.title }}</p>
             
        <p class="text-left">{{ course.brief_description }}</p>
            <p class="text-left">{{ course.duration }}</p>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import courseAppleImg from '../../../../assets/course_img_1.png'
export default {
    props: ['course', 'showChipStatus'],
   
    data(){
        return {
            courseAppleImg: courseAppleImg
        }
    },
    watch: {
       
    },
    mounted(){
       
    },
    methods: {
        showChip(course){
            return (this.showChipStatus && course.status != null && course.status != 'not_started');

        },
        getColorChip(course){
            switch (course.status) {
                case 'completed':
                        return 'green';
                case 'in_progress':
                        return 'orange';
            
                default:
                        return 'red';
            }
        },
        getCourseStatus(course){
            switch (course.status) {
                case 'completed':
                    return 'Completado';
                case 'in_progress':
                    return 'En curso';
                    
            
                default:
                    return '-';
            }
        }
       
    }
}
</script>

<style lang="scss">
    .courses{

        &-item-chip{
           display: flex;
             justify-self: end;

            // width: -webkit-fill-available;
        }
        &-item-container{
            border: 1px solid rgb(187, 185, 185);
            border-radius: 0.8rem;
            display: flex;
            align-items: flex-start;
            padding: 10px 5px;
        }

        &-img{
            flex: 0 0 30%; /* Enforces exactly 50% width */
        }


        &-item-texts{
            flex: 0 0 70%; /* Enforces exactly 50% width */
            justify-items: flex-start;
            font-size: 0.86rem;
            color: #605f5f; //var(--v-normalText-base) !important;
            p{
                padding: 3px 0;
                margin-bottom: 0;
            }

            &-title{
                 color:var(--v-normalText-base) !important;
                font-weight: 700;
                font-size: 1rem;
            }
        }
    }
</style>